import { parse } from 'querystring';

import React from 'react';
import { Link, Redirect, useLocation } from 'react-router-dom';

import { Navigation } from 'main/components';

import CookiesBanner from './CookiesBanner';

import orqaLogo from '../assets/images/orqa-logo.png';
// import facebookIcon from '../assets/images/icon-social-facebook.svg';
// import instagramIcon from '../assets/images/icon-social-instagram.svg';
// import youtubeIcon from '../assets/images/icon-social-youtube.svg';
// import xIcon from '../assets/images/icon-social-x.svg';

const Layout: React.FC = ({ children }) => {
  const { search } = useLocation();

  console.log(window.location.pathname);

  const { seoredirect } = parse(search.slice(1));
  if (seoredirect) {
    return <Redirect to={seoredirect as string} />;
  }

  return (
    <div className="container">
      <div className="container__overlay" />

      <header className="header">
        <div className="header__top">
          <div className="header__branding">
            <Link to="/" onMouseDown={event => event.preventDefault()}>
              <img src={orqaLogo} alt="ORQA Logo" />
            </Link>
          </div>
          <a
            href="https://shop.orqafpv.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--secondary btn--sml"
            onMouseDown={event => event.preventDefault()}
          >
            Shop
          </a>
        </div>
      </header>

      <div className="header__bottom">
        <Navigation />
        <div className="header__bottom__wrapper">
          {/* <div className="social__wrapper__mobile">
            <div className="social">
              <a
                href="https://www.facebook.com/OrqaFPV"
                target="_blank"
                rel="noopener noreferrer nofollow"
                title="Facebook: ORQA"
                onMouseDown={event => event.preventDefault()}
              >
                <img
                  src={facebookIcon}
                  alt="Facebook Social Media Icon"
                  className="header__icon"
                />
              </a>
              <a
                href="https://www.instagram.com/orqafpv/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                title="Instagram: ORQA"
                onMouseDown={event => event.preventDefault()}
              >
                <img
                  src={instagramIcon}
                  alt="Instagram Social Media Icon"
                  className="header__icon"
                />
              </a>
              <a
                href="https://www.youtube.com/channel/UCGPZJ5j16slPTObilo8viwg/featured"
                target="_blank"
                rel="noopener noreferrer nofollow"
                title="Youtube: ORQA"
                onMouseDown={event => event.preventDefault()}
              >
                <img
                  src={youtubeIcon}
                  alt="Youtube Social Media Icon"
                  className="header__icon"
                />
              </a>
              <a
                href="https://twitter.com/OrqaFPV"
                target="_blank"
                rel="noopener noreferrer nofollow"
                title="X: ORQA"
                onMouseDown={event => event.preventDefault()}
              >
                <img
                  src={xIcon}
                  alt="X Social Media Icon"
                  className="header__icon"
                />
              </a>
            </div>
          </div> */}
        </div>
      </div>
      <div className="container__content">
        <main className="container__children">{children}</main>
        {window.location.pathname === '/developer-program' ? null : (
          <CookiesBanner />
        )}
      </div>
      <div className="container__lightoverlay" />
    </div>
  );
};

export default Layout;
